import Axios from '@/axios'

// 创建支付宝酒店
// 接口权限名：web:zfbHotel:create
export const ZfbHotelCreate = data => {
  return Axios({
    url: `/device-manager/web-api/zfb-hotel/create`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 创建支付宝酒店
// 接口权限名：web:zfbHotel:update
export const ZfbHotelUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/zfb-hotel/update`,
    method: 'POST',
    type: 'json',
    data
  })
}
